import React from "react"
import { Body } from "@walmart-web/livingdesign-components"
import { useIntl } from "react-intl"

const DescriptionTable: React.FC = () => {
	const intl = useIntl()
	return (
		<Body>
			<ol>
				<li>
					{intl.formatMessage(
						{
							id: `phronesis.customerbehavior.application.customerProfiling.metricsBySegments.description.distribution`,
						},
						{ b: (str) => <b>{str}</b> }
					)}
				</li>
				<li>
					{intl.formatMessage(
						{
							id: `phronesis.customerbehavior.application.customerProfiling.metricsBySegments.description.walmartDistribution`,
						},
						{ b: (str) => <b>{str}</b> }
					)}
				</li>
				<li>
					{intl.formatMessage(
						{
							id: `phronesis.customerbehavior.application.customerProfiling.metricsBySegments.description.reach`,
						},
						{ b: (str) => <b>{str}</b> }
					)}
				</li>
			</ol>
		</Body>
	)
}

export default DescriptionTable
